import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ASYNC_STATUS, isLoading as isLoadingHelper } from '@scripts/utilities/redux-helpers.js';
import RestClient from '@scripts/utilities/rest-client.js';


const initialState = {
  status: ASYNC_STATUS.IDLE,
  /**
   * A list of nft collections
   */
  collections: []
};


var fetchThunk = createAsyncThunk('nfts/fetch', function() {
  return RestClient.get('/wp-json/sbm/v1/nfts/');
});



const nftSlice = createSlice({
    name: 'nfts',
    initialState: initialState,
    reducers: { },
    extraReducers: function(builder) {
      builder
        .addCase(fetchThunk.pending, function(state) {
          state.status = ASYNC_STATUS.INPROGRESS;
        })
        .addCase(fetchThunk.fulfilled, function(state, action) {
          state.status = ASYNC_STATUS.COMPLETE;
          state.collections = action.payload;
        });
    }
});


/**
 * helper function for retrieving the nfts from the store
 */
function getNFTState(state) {
  return state.nfts;
}
export function isLoading(state) {
  return isLoadingHelper(getNFTState(state).status);
}
/**
 * Return all nfts, including nfts which have been automatically generated.
 */
export function getAllCollections(state) {
  return getNFTState(state).collections;
}
/**
 * return reviewed NFT Collections. i.e., only those collections that have been
 * reviewed by Collective Shift.
 */
export function getCollections(state) {
  var collections = getAllCollections(state);
  var result = [];

  for (var i = 0; i < collections.length; i++) {
    if (collections[i].reviewed) {
      result.push(collections[i]);
    }
  }

  return result;
}
export function getCollectionById(state, id) {
  var result = null;
  var collections = getAllCollections(state);

  if (collections.length) {
    for (var i = 0; i < collections.length; i++) {
      if (collections[i].id == id) {
        result = collections[i];
        break;
      }
    }
  }


  return result;
}


/**
 * Action creators
 */
export var fetch = function() {
  return function(dispatch, getState) {
    var state = getState();
    var nfts = getNFTState(state);

    if (nfts.status == ASYNC_STATUS.IDLE) {
      dispatch(fetchThunk());
    }
  };
};


export default nftSlice.reducer;

